import { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '../locales/translations';

const LanguageContext = createContext();

const languageNames = {
  en: 'English',
  es: 'Español',
  it: 'Italiano',
  de: 'Deutsch',
  ja: '日本語',
  ko: '한국어',
  zh: '中文',
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [language]);

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, languageNames, availableLanguages: Object.keys(languageNames) }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
